export interface CreateShelfTypeTempChangeRequest {
  ids: number[]
}

export function CreateShelfTypeTempChangeRequestToJSON(
  value: CreateShelfTypeTempChangeRequest
): any {
  return {
    ids: value.ids.length > 0 ? value.ids : undefined
  }
}
